import { routeList } from '@/router/helpers/routes'

export default [{
	path: routeList.USER_AREA_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.USER_AREA_PROFILE_PATH,
	name: routeList.USER_AREA_PROFILE_NAME,
	component: () => import('@/views/userArea/Profile')
},
/* ***********************************************
*                    DEFINITIONS                 *
*********************************************** */
{
	path: routeList.USER_AREA_DEFINITIONS_PATH,
	name: routeList.USER_AREA_DEFINITIONS_NAME,
	component: () => import('@/views/ThirdLevelMenu')
}, {
	path: routeList.USER_AREA_DEFINITIONS_ACTIVE_CHANNELS_PATH,
	name: routeList.USER_AREA_DEFINITIONS_ACTIVE_CHANNELS_NAME,
	component: () => import('@/views/userArea/definitions/ActiveChannels')
}, {
	path: routeList.USER_AREA_DEFINITIONS_PASSWORD_CHANGE_PATH,
	name: routeList.USER_AREA_DEFINITIONS_PASSWORD_CHANGE_NAME,
	component: () => import('@/views/userArea/definitions/PasswordChange')
}, {
	path: routeList.USER_AREA_DEFINITIONS_FRIENDLY_USERNAME_PATH,
	name: routeList.USER_AREA_DEFINITIONS_FRIENDLY_USERNAME_NAME,
	component: () => import('@/views/userArea/definitions/FriendlyUsername')
}, {
	path: routeList.USER_AREA_DEFINITIONS_ACCOUNTS_GROUPS_PATH,
	name: routeList.USER_AREA_DEFINITIONS_ACCOUNTS_GROUPS_NAME,
	component: () => import('@/views/UnderDevelopment')
}, {
	path: routeList.USER_AREA_DEFINITIONS_HISTORY_PATH,
	name: routeList.USER_AREA_DEFINITIONS_HISTORY_NAME,
	component: () => import('@/views/userArea/definitions/History')
}, {
	path: routeList.USER_AREA_DEFINITIONS_SECURE_ASSOCIATION_ENROLLMENT_PATH,
	name: routeList.USER_AREA_DEFINITIONS_SECURE_ASSOCIATION_ENROLLMENT_NAME,
	component: () => import('@/views/userArea/definitions/SecureAssociationEnrollment')
}, {
	path: routeList.USER_AREA_DEFINITIONS_NOTIFICATIONS_PATH,
	name: routeList.USER_AREA_DEFINITIONS_NOTIFICATIONS_NAME,
	component: () => import('@/views/userArea/definitions/Notifications')
}]
